import styled from 'styled-components';

import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';

export const PageBottom = styled(PageContent)`
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;

  align-items: center;
  justify-content: space-between;
`;
